import styled from 'styled-components';
import { colours, customFonts, fontSizes } from "../../constants/css";
export var PageTitle = styled.h1.withConfig({
  displayName: "style__PageTitle",
  componentId: "sc-1298hwo-0"
})(["font-family:", ";font-size:", ";font-weight:normal;color:", ";margin:0;"], customFonts.ciutadellaMed, fontSizes.xxl, colours.qantasCharcoal);
export var ErrorWrapper = styled.div.withConfig({
  displayName: "style__ErrorWrapper",
  componentId: "sc-1298hwo-1"
})(["background-image:linear-gradient(216deg,rgba(255,255,255,0),#d4d4d4);padding-top:2rem;"]);